export default __webpack_public_path__ + "static/media/person_3@3x.3f900a09.png";